import { useAppSelector } from '../configuration/setup/hooks';
import { getUserAccount } from '../configuration/login/loginSlice';
import { useFetchRentalCompanyPartnersQuery } from '../services/api/rental.api';

export const useShouldShowPartnerBanner = (): boolean => {
    const accountId = useAppSelector(getUserAccount);
    if (accountId === undefined) {
        throw new Error('Account id is not available');
    }
    const { data } = useFetchRentalCompanyPartnersQuery({ accountId });
    return data?.length === 0;
};
